import React from 'react';
import { CheckCircleIcon, EyeIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function VisionSection() {
  return <section className="w-full bg-gradient-to-b from-blue-50 to-white py-16 md:py-24" data-id="element-547">
      <div className="max-w-4xl mx-auto px-6" data-id="element-548">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-549">
          Imagina esto en unas semanas…
        </h2>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-gray-100 mb-8" data-id="element-550">
          <p className="text-lg text-gray-700 mb-6" data-id="element-551">
            En lugar de sentir miedo al Administrador de Anuncios, haces esto:
          </p>

          <div className="space-y-6" data-id="element-552">
            <div className="flex gap-4 items-start" data-id="element-553">
              <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-554" />
              <p className="text-lg text-gray-700" data-id="element-555">
                <strong data-id="element-556">Entras a tu cuenta de Meta Ads sin pánico.</strong>
              </p>
            </div>

            <div className="flex gap-4 items-start" data-id="element-557">
              <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-558" />
              <p className="text-lg text-gray-700" data-id="element-559">
                Sabes cómo crear una campaña nueva desde cero.
              </p>
            </div>

            <div className="flex gap-4 items-start" data-id="element-560">
              <TargetIcon className="w-6 h-6 text-[#0866FF] flex-shrink-0 mt-1" data-id="element-561" />
              <p className="text-lg text-gray-700" data-id="element-562">
                Entiendes qué objetivo elegir (mensajes, tráfico, leads, ventas,
                etc.).
              </p>
            </div>

            <div className="flex gap-4 items-start" data-id="element-563">
              <EyeIcon className="w-6 h-6 text-purple-500 flex-shrink-0 mt-1" data-id="element-564" />
              <p className="text-lg text-gray-700" data-id="element-565">
                Sabes cómo elegir el público, el presupuesto y la ubicación de
                los anuncios.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 rounded-2xl p-8 md:p-10 mb-8" data-id="element-566">
          <p className="text-lg text-gray-700 mb-4" data-id="element-567">
            <strong data-id="element-568">Tienes claros los elementos básicos:</strong>
          </p>
          <ul className="space-y-3 text-gray-700" data-id="element-569">
            <li className="flex items-center gap-3" data-id="element-570">
              <span className="w-2 h-2 bg-[#0866FF] rounded-full" data-id="element-571"></span>
              Cómo escribir un anuncio simple pero efectivo.
            </li>
            <li className="flex items-center gap-3" data-id="element-572">
              <span className="w-2 h-2 bg-[#0866FF] rounded-full" data-id="element-573"></span>
              Cómo poner una buena imagen/video.
            </li>
            <li className="flex items-center gap-3" data-id="element-574">
              <span className="w-2 h-2 bg-[#0866FF] rounded-full" data-id="element-575"></span>
              Cómo lanzar sin romper nada.
            </li>
          </ul>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-2xl p-8 md:p-10 mb-8" data-id="element-576">
          <p className="text-xl font-semibold text-gray-900 mb-6" data-id="element-577">
            Y lo más importante:
          </p>
          <div className="space-y-4 text-gray-700" data-id="element-578">
            <p className="flex items-start gap-3" data-id="element-579">
              <TrendingUpIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-580" />
              Ya no sientes que "le vas a dar tu tarjeta a un monstruo".
            </p>
            <p className="flex items-start gap-3" data-id="element-581">
              <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-582" />
              Sabes qué esperar cuando tu campaña empiece a gastar.
            </p>
            <p className="flex items-start gap-3" data-id="element-583">
              <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-584" />
              Sabes qué números mirar (en versión principiante, sin tecnicismos
              excesivos).
            </p>
          </div>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-10 text-center" data-id="element-585">
          <p className="text-lg text-gray-300 mb-4" data-id="element-586">
            No se trata solo de "saber dónde hacer clic". Se trata de entender
            lo suficiente como para decir:
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[#0866FF]" data-id="element-587">
            "Puedo lanzar mis propias campañas básicas sin depender al 100% de
            nadie."
          </p>
        </div>

        <div className="text-center mt-12" data-id="element-588">
          <CTAButton size="large" scrollTo="pricing" data-id="element-589">
            Quiero Empezar Desde Cero →
          </CTAButton>
        </div>
      </div>
    </section>;
}